interface PricePerDayDisplayProps {
  monthlyPrice: number;
  className?: string;
  compact?: boolean;
}

export const PricePerDayDisplay = ({ 
  monthlyPrice,
  className = "",
  compact = false
}: PricePerDayDisplayProps) => {
  // Calculate price per day (monthly price / 30 days)
  const pricePerDay = (monthlyPrice / 30).toFixed(2);
  
  return (
    <div className={`text-center ${className}`}>
      <p className="text-sm text-white/60">
        = Apenas <span className="font-bold text-luxury-pinkBright">R${pricePerDay}/dia</span>
      </p>
      {!compact && (
        <p className="text-xs text-white/40 mt-0.5">
          Menos que um café ☕
        </p>
      )}
    </div>
  );
};